module.exports = __webpack_public_path__ + "img/table-bg.0a0300fc.jpg";